import { checkHomecare } from './checkHomecare';
import { checkImplantationVisit } from './checkImplantationVisit';
import { checkSuspensionVisit } from './checkSuspensionVisit';

/**
 * Business rules for determining if a padVisit should become a calendarVisit.
 * Centralizes all filtering logic for testability and reusability.
 */
export const shouldIncludeAsCalendarVisitSchedule = padVisit => {
  const isSuspension = checkSuspensionVisit(padVisit);
  const isImplantation = checkImplantationVisit(padVisit);
  const isHomecare = checkHomecare(padVisit);

  if (isSuspension) return false;
  if (!isHomecare) return false;
  if (isImplantation) return false;

  return true;
};
